/**
 * Splits a name into animated display lines.
 * - 1-2 words: one word per line
 * - 3+ words: balanced split across 2 lines
 */
export const getNameLinesWithAnimation = (
  name: string,
  baseStartFrame: number,
  charStagger: number,
) => {
  const MAX_WORDS_PER_LINE = 2;

  const words = name.trim().split(/\s+/).filter(Boolean);

  // Handle empty name
  if (words.length === 0) {
    return [{ text: '', startFrame: baseStartFrame }];
  }

  const mid = Math.ceil(words.length / MAX_WORDS_PER_LINE);

  // Split into 1-2 lines based on word count
  const lines =
    words.length <= MAX_WORDS_PER_LINE
      ? words
      : [words.slice(0, mid).join(' '), words.slice(mid).join(' ')];

  // Calculate start frame for each line (accounting for previous chars + line breaks)
  let charCount = 0;

  return lines.map((text, index) => {
    const startFrame = baseStartFrame + (charCount + index) * charStagger;
    charCount += text.length;
    return { text, startFrame };
  });
};
